import angular from 'angular';
import directive from './threat.directive';

// Validation
import threatImpactMessagesTpl from './messages/threat-impact.messages.html';
import threatProbabilityMessagesTpl from './messages/threat-probability.messages.html';


export default angular.module('app.components.advisory.bcp.threat', [])
  .directive('bcpThreat', directive)
  .controller('ThreatController', () => { /* here to provide controllerAs vm */ })
  .run(($templateCache) => {
    $templateCache.put('threat-impact.messages.html', threatImpactMessagesTpl);
    $templateCache.put('threat-probability.messages.html', threatProbabilityMessagesTpl);
  })
  .name;

console.log('app.components.advisory.bcp.threat created');
